$(function() {
    $('#articles-wrapper').mixItUp ({
        load: {
            sort: 'order:asc'
        },
        animation: {
            effects: 'fade scale',
            duration: 600
        },
        selectors: {
            target: '.article',
            filter: '.filter-btn'
        },
        callbacks: {
            onMixEnd: function(state) {
                console.log(state)
            }
        }
    });
});
